const API_VERSION = process.env.API_VERSION ? process.env.API_VERSION : 'v1'
const API_HOST = process.env.API_HOST
  ? `http://${process.env.API_HOST}`
  : 'https://api.workwhilejobs.com'
const API_URL = `${API_HOST}/${API_VERSION}`

export { API_URL, API_HOST }
